import React from 'react'

const AxonallLogo = ({ className = "", size = "text-2xl", color = "text-black" }) => {
  return (
    <span 
      className={`font-ptSerifRegular tracking-extra-ultra-wide ${color} ${size} ${className}`}
      style={{ fontFamily: "'PTSerif-Regular', 'PT Serif', Georgia, 'Times New Roman', serif" }}
    >
      AXONALL<span>.</span>
    </span>
  )
}

export default AxonallLogo
